module.exports = __webpack_public_path__ + "img/blue-logo.46bd24e1.png";